import { Heading } from '@digdir/designsystemet-react';

import styled from '../../../../../../../styled';

export const ErrorSummaryHeader = styled(Heading)`
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  justify-items: center;
`;

export const ErrorGroupWrapper = styled.div`
  margin-bottom: var(--ds-size-6);
`;
